<template>
  <div class="main-index">
    <div class="main-head" :style="dynamicStyle">
      <div class="mian-content">
        <div class="main-tab">
          <div class="tab" v-for="(item, index) in tabs" :key="index"  @click="goPagePart(index)">
            {{ item }}
          </div>
        </div>
        <template v-if="isInner">
          <div id="tab_1" ref="tab0" class="activity-content">
            <div class="activity-title flex-center" >
              一重礼·U豆任性送
            </div>
            <activity-item title="福利1  好事成双，U豆双送" description="每日通过U+APP与网页端签到，分别得奖励" btn-type="go" @go="doubleGood"></activity-item>
            <activity-item title="福利2 邀请好友赢U豆" description="简单三步，立赢U豆，上不封顶" btn-type="invite"></activity-item>
          </div>
          <div id="tab_2" ref="tab1" class="activity-content" >
            <div class="activity-title flex-center">
              二重礼 奖励送不停
            </div>
            <activity-item title="福利1 U+直播间20万福利季" description="报名开播&分享直播，20万奖金池等你瓜分" btn-type="go" @go="broadcastWelfare"></activity-item>
            <activity-item title="福利2  灭“异”行动，享多重奖池" description="通过案例学习，加强异常事件防范" btn-type="removeException"></activity-item>
            <activity-item title="福利3  一览恒生解决方案，好礼大派送" description="周周抽奖抽到手软" btn-type="solution"></activity-item>
            <!-- <activity-item title="福利3  天天点评，邀请有礼" description="维护/实施/销售，邀请客户完成点评，" description1="根据完成点评条数获得奖励" btn-type="waiting"></activity-item> -->
          </div>
          <div id="tab_3" ref="tab2" class="activity-content">
            <div class="activity-title flex-center">
              三重礼 惊喜礼包待你拆
            </div>
            <activity-item title="福利1  打卡学习，悄悄变强大" description="U豆、包包、风扇、水杯、筋膜枪等多重好礼大派送" btn-type="go" @go="courseClock"></activity-item>
            <!-- <activity-item title="福利2  年度“服务之星”评选" description="Pick您心中的“服务之星”快来为ta点赞吧～" btn-type="go" @go="goServiceStar"></activity-item> -->
            <activity-item title="福利2  年度学习之星，一起来PK" description="学有所用，学有所得，最高10万U豆悬赏学习之星"  btn-type="go" @go="goLearningStar"></activity-item>
          <!-- <activity-item title="福利4  1024程序员节，好礼不断" description="一大波活动来袭，好礼不断，邀您参加" btn-type="go" @go="programmer"></activity-item> -->
          </div>
        </template>
        <template v-else>
          <div id="tab_1" ref="tab0" class="activity-content">
            <div class="activity-title flex-center" >
              一重礼  大奖任性送
            </div>
            <activity-item title="福利1  一起点评赢大奖" description="自己点评+邀请同事点评都可抽奖100%有奖,最高有机会得戴森吸尘器" description1="请在U+APP登录,首页点击“一起点评赢大奖“进入活动页参与活动" btn-type="warning"></activity-item>
            <activity-item title="福利2  访问智能客服，得惊喜盲盒" description="50的整数倍会话者获得盲盒一份
            " description1="选择技能组与机器人对话则记一次会话" btn-type="go" @go="openServiceDialog"></activity-item>
          </div>
          <div id="tab_2" ref="tab1" class="activity-content">
            <div class="activity-title flex-center">
              二重礼  U豆送不停
            </div>
            <activity-item title="福利1  好事成双，U豆双送" description="每日通过U+APP与网页端登录签到，分别得奖励" btn-type="go" @go="doubleGood"></activity-item>
            <activity-item title="福利2  天天点评，U豆送不停" description="完成需求、项目、事件评价获得U豆奖励" description1="完成多条点评还有千元盲盒礼" btn-type="go" @go="everyDayComment"></activity-item>
            <activity-item title="福利3 邀请好友赢U豆" description="简单三步，立赢U豆，上不封顶" btn-type="invite"></activity-item>
          </div>
          <div id="tab_3"  ref="tab2" class="activity-content">
            <div class="activity-title flex-center">
              三重礼 惊喜礼包待你拆
            </div>
            <activity-item title="福利1  打卡学习，悄悄变强大" description="U豆、包包、风扇、水杯、筋膜枪等多重好礼大派送" btn-type="go" @go="courseClock"></activity-item>
            <!-- <activity-item title="福利2  年度“服务之星”评选" description="Pick您心中的“服务之星”，快来为ta投票和点赞吧～" description1="投票即可获得线上抽奖机会" btn-type="go" @go="goServiceStar"></activity-item> -->
            <activity-item title="福利2  年度学习之星，一起来PK" description="学有所用，学有所得，最高10万U豆悬赏学习之星" btn-type="go" @go="goLearningStar"></activity-item>
            <activity-item title="福利3  一览恒生解决方案，好礼大派送" description="周周抽奖抽到手软" btn-type="solution"></activity-item>
          </div>
        </template>
        <div id="tab_4"  ref="tab3" class="activity-content">
          <div class="activity-title flex-center">
            四重礼 多款组件免费用
          </div>
          <activity-item title="0元，速领" description="多款组件产品免费试用" btn-type="go" @go="goApi"></activity-item>
        </div>
        <div class="font-white">更多精彩活动待解锁，持续关注</div>
        <div class="welfare-wall flex-center" ref="tab4">
          限时低豆值抢兑 爆品回馈福利墙
        </div>
        <div class="welfare-content ">
          <p class="welfare-title">双12好礼秒杀剧透（10:00 AM）</p>
          <template v-if="isInner">
            <div class="gift-list-wrap">
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift1.png" />
                <div class="gift-price">69999U豆</div>
                <del class="old-price">原价:99750U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift2.png" />
                <div class="gift-price">69999U豆</div>
                <del class="old-price">原价:100000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift3.png" />
                <div class="gift-price">19999U豆</div>
                <del class="old-price">原价:45000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift4.png" />
                <div class="gift-price">19999U豆</div>
                <del class="old-price">原价:26000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift5.png" />
                <div class="gift-price">11999U豆</div>
                <del class="old-price">原价:16500U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift6.png" />
                <div class="gift-price">11999U豆</div>
                <del class="old-price">原价:17500U豆</del>
              </div>
            </div>
            <div class="gift-list-wrap">
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift7.png" />
                <div class="gift-price">11999U豆</div>
                <del class="old-price">原价:18000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift8.png" />
                <div class="gift-price">9999U豆</div>
                <del class="old-price">原价:17500U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift9.png" />
                <div class="gift-price">6999U豆</div>
                <del class="old-price">原价:13500U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift10.png" />
                <div class="gift-price">5999U豆</div>
                <del class="old-price">原价:10000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift11.png" />
                <div class="gift-price">1999U豆</div>
                <del class="old-price">原价:5000U豆</del>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="gift-list-wrap">
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift3.png" />
                <div class="gift-price">69999U豆</div>
                <del class="old-price">原价:100000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift1.png" />
                <div class="gift-price">69999U豆</div>
                <del class="old-price">原价:99750U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/giftout3.png" />
                <div class="gift-price">39999U豆</div>
                <del class="old-price">原价:50000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/giftout4.png" />
                <div class="gift-price">19999U豆</div>
                <del class="old-price">原价:32000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift3.png" />
                <div class="gift-price">19999U豆</div>
                <del class="old-price">原价:45000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/giftout6.png" />
                <div class="gift-price">19999U豆</div>
                <del class="old-price">原价:37500U豆</del>
              </div>
            </div>
            <div class="gift-list-wrap">
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/giftout7.png" />
                <div class="gift-price">19999U豆</div>
                <del class="old-price">原价:24000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/giftout8.png" />
                <div class="gift-price">19999U豆</div>
                <del class="old-price">原价:26000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/giftout9.png" />
                <div class="gift-price">15999U豆</div>
                <del class="old-price">原价:20000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift7.png" />
                <div class="gift-price">11999U豆</div>
                <del class="old-price">原价:18000U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift5.png" />
                <div class="gift-price">11999U豆</div>
                <del class="old-price">原价:16500U豆</del>
              </div>
              <div class="gift-list">
                <img class="gift-img" src="~@/assets/activity/shuang12/gift6.png" />
                <div class="gift-price">11999U豆</div>
                <del class="old-price">原价:17500U豆</del>
              </div>
            </div>
          </template>
          <div class="flex-between">
            <div>
                <span class="scan-tip1">打开U+App扫码进入商城 锁定您的秒杀好礼（限量）</span>
                <p class="scan-tip2">具体以U+商城页面展示为准</p>
            </div>
            <img class="shopping-code" src="~@/assets/activity/november/shopping_code.png">
          </div>
        </div>
        <div class="font-bottom">
          活动联系人：李莜 0571-26691423</br>
          最终解释权归恒生电子股份有限公司</div>
        <img src="~@/assets/activity/november/heart_face.png" class="heart-face"/>
        <img src="~@/assets/activity/november/smile_face.png" class="smile-face"/>
        <img src="~@/assets/activity/november/mail_box.png" class="mail-box"/>
      </div>
      <img src="~@/assets/activity/november/color_cloud.png" class="color-cloud"/>
    </div>
  </div>
</template>
<script>
import ActivityItem from '../components/ActivityItem.vue'
import { mapGetters } from 'vuex'
export default {
  components: { ActivityItem },
  name: 'ActivityIndex',
  data() {
    return {
      windowWidth: 1280, // 视口宽度
      tabs: ['一重礼', '二重礼', '三重礼', '四重礼', '爆品回馈福利墙'],
      // seckillDate: window.competitionResource.seckillDate,
      // gift1: window.competitionResource.gift1 || '100U豆',
      // gift2: window.competitionResource.gift2 || '50U豆',
      // gift3: window.competitionResource.gift3 || '1U豆',
      modal: false
    }
  },
  computed: {
    ...mapGetters(['uPlusUser']),
    // 1:内部，0:外部/游客
    isInner() {
      let isInner = this.uPlusUser ? this.uPlusUser.isInner : ''
      return String(isInner) === '1'
      // return false
    },
    dynamicStyle() {
      const scale = this.windowWidth / 1920
      return {
        padding: `${1535 * scale}px 0 ${440 * scale}px`
        // mainContentTop:``,
        // mainContentPaddingBottom:``,
      }
    }
  },
  mounted() {
    this.selfAdaption()
    window.addEventListener('resize', this.selfAdaption, false)
  },
  methods: {
    //线索登记
    solutionList() {
      location.href = '/openplat-front/opportunityCollect'
    },
    //天天点评
    everyDayComment() {
      location.href = '/html5/comment-every-day/'
    },
    //直播不打烊
    // broadcastAlive() {
    //   location.href = '/openplat-front/broadcastAlive'
    // },
    //组件0元试用
    goApi() {
      location.href = '/openplat-front/apiActivity'
    },
    //U+直播间20万福利季
    broadcastWelfare() {
      location.href = '/openplat-front/broadcastWelfare'
    },
    //访问智能客服
    openServiceDialog() {
      this.$parent.$refs.backtotopBox.handleKFClick()
    },
    //好事成双
    doubleGood() {
      location.href = '/cloud-console/account/uPay'
    },
    //课堂9天打卡
    courseClock() {
      location.href = '/openplat-front/courseClock'
    },
    // 跳转到服务之星
    goServiceStar() {
      location.href = '/online-console/serviceStar'
    },
    // 跳转到学习之星
    goLearningStar() {
      location.href = '/openplat-front/learningStar'
    },
    //产品中心查看
    // productList() {
    //   location.href = '/openplat-front/productList'
    // },
    // jumpTo() {
    //   location.href = "/openplat-front/opportunityCollect";
    // },
    goPagePart(index) {
      // this.activeTab = index
      let diff = -20
      this.procPageScroll(getTrueTop(this.$refs['tab' + index]) + diff, 'down')
    },
    isIE() {
      const userAgent = navigator.userAgent.toLocaleLowerCase()
      const ie11reg = /(trident)\/([\d.]+)/
      if (
        (userAgent.indexOf('compatible') > -1 &&
          userAgent.indexOf('msie') > -1) ||
        userAgent.match(ie11reg)
      ) {
        return true
      }
      return false
    },
    procPageScroll(toPosition, type) {
      try {
        if (this.isIE()) {
          throw new Error('')
        } else {
          window.scrollTo({ top: toPosition, behavior: 'smooth' })
        }
      } catch (e) {
        this.manualScrollDown(toPosition)
      }
    },
    manualScrollDown(targetPos) {
      let top = this.scrollTop
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top += 50
        if (top >= targetPos) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    // 页面自适应
    selfAdaption() {
      const oWidth =
        document.documentElement.clientWidth ||
        document.body.clientWidth ||
        window.innerWidth
      this.windowWidth = oWidth
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.selfAdaption, false)
  }
}

function getTrueTop(el) {
  let top = 0
  let parent = el
  while (parent) {
    top += parent.offsetTop
    parent = parent.offsetParent
  }
  return top
}
</script>
<style lang="scss" scoped>
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-index {
  background: #fff0ed;
  overflow-x: hidden;
  .main-head {
    width: 100%;
    background: url('~@/assets/activity/november/main_head.png') center 0 /
      contain no-repeat;
    padding: 1535px 0 400px;
    position: relative;
  }
  .mian-content {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  .main-tab {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 80px;
    .tab {
      width: 210px;
      height: 60px;
      background-image: linear-gradient(180deg, #ffdcdc 0%, #ffb1b1 99%);
      border: 1px solid rgba(255, 245, 244, 1);
      box-shadow: 0px 1px 3px 0px rgba(248, 166, 119, 0.8);
      border-radius: 30px;
      font-family: PingFangSC-Medium;
      font-size: 24px;
      color: #bf4242;
      text-align: center;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      &:hover {
        background-image: linear-gradient(180deg, #ffb2b2 0%, #f01c1c 99%);
        border: 1px solid rgba(255, 245, 244, 1);
        box-shadow: 0px 1px 3px 0px rgba(248, 166, 119, 0.8);
        border-radius: 30px;
        color: #fff;
      }
    }
  }
  .activity-content {
    background: #fffbf8;
    border: 1px solid rgba(238, 143, 141, 1);
    border-radius: 12px;
    margin: 0 auto 40px;
    padding-bottom: 40px;
    .activity-title {
      width: 554px;
      height: 60px;
      margin: 0 auto 30px;
      font-family: PingFangSC-Medium;
      font-size: 30px;
      color: #fff;
      text-align: center;
      font-weight: 500;
      background-image: linear-gradient(180deg, #f9aaa9 0%, #e88482 98%);
      border: 1px solid rgba(238, 143, 141, 1);
      border-radius: 0px 0px 12px 12px;
    }
  }
  .font-white {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #df7f7f;
    text-align: center;
    margin-bottom: 40px;
    line-height: 24px;
  }
  .welfare-wall {
    background-image: linear-gradient(180deg, #f9aaa9 0%, #e88482 98%);
    border: 1px solid rgba(238, 143, 141, 1);
    border-radius: 12px;
    width: 1200px;
    margin: 0 auto;
    height: 68px;
    line-height: 68px;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 30px;
    color: #fff;
    font-weight: 500;
  }
  .welfare-content {
    background: #fffbf8;
    border: 1px solid rgba(238, 143, 141, 1);
    border-radius: 12px;
    width: 1200px;
    margin: 0 auto 40px;
    text-align: center;
    padding: 40px 115px 60px;
    .welfare-title {
      font-family: PingFangSC-Medium;
      font-size: 24px;
      color: #ab1515;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
      height: 60px;
    }
    .gift-list-wrap {
      // width: 966px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      margin-bottom: 26px;
      text-align: left;
      .gift-list {
        width: 140px;
        border-radius: 12px;
        overflow: hidden;
        border: 1.49px solid rgba(255, 234, 234, 1);
        margin-right: 25px;
        &:last-of-type {
          margin-right: 0;
        }
      }
      .gift-img {
        width: 140px;
        height: 140px;
      }
      .gift-price {
        background: #fffcfb;
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #ab1515;
        line-height: 20px;
        font-weight: 500;
        margin: 6px 0 3px;
        padding-left: 6px;
      }
      .old-price {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #df7f7f;
        padding-left: 6px;
        margin-bottom: 8px;
      }
    }
    .scan-tip1 {
      font-family: PingFangSC-Medium;
      font-size: 30px;
      color: #d6352e;
      line-height: 48px;
      height: 48px;
      font-weight: 500;
      // padding-left: 48px;
      margin-bottom: 26px;
    }
    .scan-tip2 {
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #df7f7f;
      text-align: left;
      // padding-left: 48px;
    }
    .mt-30 {
      margin-top: 30px;
    }
  }
  .font-bottom {
    line-height: 48px;
    // padding-bottom: 123px;
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #df7f7f;
    text-align: center;
  }
  .flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .shopping-code {
    background: #ffffff;
    border: 1px solid rgba(241, 177, 118, 1);
    border-radius: 8px;
    width: 250px;
    height: 250px;
  }
  .text-left {
    text-align: left;
  }
  .heart-face,
  .smile-face,
  .mail-box {
    position: absolute;
  }
  .heart-face {
    width: 206px;
    height: 206px;
    right: -206px;
    top: 484px;
  }
  .smile-face {
    width: 217px;
    height: 217px;
    left: -217px;
    top: 962px;
  }
  .mail-box {
    width: 354px;
    height: 354px;
    left: -354px;
    bottom: 250px;
  }
}
.color-cloud {
  position: absolute;
  width: 100%;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/activities/novemberWelfare/novemberWelfare.vue